import SchemeEditor from '@/containers/schemeEditor';
import Settings from '@/containers/settings';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Organisation } from '../types';
import { Route } from './types';

const SchemeTemplate = () => {
  const { schemeId } = useParams<{ schemeId: string }>();
  return <SchemeEditor schemeId={schemeId} />;
};

export const settingsRoutes = (organisation: Organisation): Route[] => [
  {
    path: `/${organisation.key}/settings`,
    Component: () => <Settings />,
  },
  {
    path: `/${organisation.key}/settings/template/:schemeId`,
    Component: SchemeTemplate,
  },
];
